// Local cache utility - localStorage for persistent data, in-memory Map for search results
const CACHE_PREFIX = 'vrd_cache_'

// In-memory cache for short-lived data (search results)
const memoryCache = new Map()

// --- localStorage cache (persistent, survives page refresh) ---

export function getCache(key) {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + key)
    if (!raw) return null
    const { data, expiresAt } = JSON.parse(raw)
    if (Date.now() > expiresAt) {
      localStorage.removeItem(CACHE_PREFIX + key)
      return null
    }
    return data
  } catch {
    return null
  }
}

export function setCache(key, data, ttlMinutes = 10) {
  try {
    const entry = {
      data,
      expiresAt: Date.now() + ttlMinutes * 60 * 1000
    }
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify(entry))
  } catch {
    // localStorage full or unavailable - ignore
  }
}

export function clearCache(key) {
  if (key) {
    localStorage.removeItem(CACHE_PREFIX + key)
  } else {
    // Clear all vrd_cache_ entries
    const keys = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith(CACHE_PREFIX)) keys.push(k)
    }
    keys.forEach(k => localStorage.removeItem(k))
  }
}

// --- In-memory cache (fast, lost on page refresh) ---

export function getMemCache(key) {
  const entry = memoryCache.get(key)
  if (!entry) return null
  if (Date.now() > entry.expiresAt) {
    memoryCache.delete(key)
    return null
  }
  return entry.data
}

export function setMemCache(key, data, ttlMinutes = 2) {
  memoryCache.set(key, {
    data,
    expiresAt: Date.now() + ttlMinutes * 60 * 1000
  })
  // Evict old entries if map gets too large
  if (memoryCache.size > 200) {
    const now = Date.now()
    for (const [k, v] of memoryCache) {
      if (now > v.expiresAt) memoryCache.delete(k)
    }
  }
}

export function clearMemCache() {
  memoryCache.clear()
}
